import * as yup from 'yup';
import ValidationUtil from "../Utils/ValidationUtil";

class ForgotValidation {

    static async validate(form) {
        try {

            let validate = yup.object().shape({
                email: yup
                    .string()
                    .email(ValidationUtil.MSG_FIELD_EMAIL)
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
            });

            validate.validateSync(form, {abortEarly: false})

            return true;

        } catch (e) {
            let erros = [];
            e.inner.forEach(function (value, index) {
                erros[value.path] = value.message;
            });

            return erros;
        }
    }

}

export default ForgotValidation;